import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Production Status",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-production-status",
    args: {
        type: "open",
        text: "Production Status",
    },
    argTypes: {
        type: {
            control: "text",
            description: "Type of production status",
            table: {
                type: { summary: "string" },
                defaultValue: { summary: "open" },
            },
        },
        text: {
            control: "text",
            description: "Text content of the production status",
            table: {
                type: { summary: "string" },
                defaultValue: { summary: "Production Status" },
            },
        },
    },
};

const Template = ({ type, text }) => html`
    <ux-iws-production-status type="${type}">
        ${text}
    </ux-iws-production-status>
`;

export const Open = Template.bind({});
Open.args = {
    type: "open",
    text: "Open",
};

export const Canceled = Template.bind({});
Canceled.args = {
    type: "canceled",
    text: "Canceled",
};

export const InProduction = Template.bind({});
InProduction.args = {
    type: "in_production",
    text: "In Production",
};

export const Invoiced = Template.bind({});
Invoiced.args = {
    type: "invoiced",
    text: "Invoiced",
};

export const Completed = Template.bind({});
Completed.args = {
    type: "completed",
    text: "Completed",
};
